<template>
  <span v-if="isSuperAdmin" class="super-admin-badge-host">
    <v-tooltip v-model="tooltipOpen" bottom open-on-focus :open-delay="150">
      <template #activator="{ on, attrs }">
        <span
          class="super-admin-badge"
          :class="{ 'super-admin-badge--compact': compact }"
          v-bind="attrs"
          v-on="on"
          :tabindex="focusable ? 0 : null"
          :aria-label="description"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
            <path d="M12 3 4.5 6v5c0 4.8 3.1 8.2 7.5 10 4.4-1.8 7.5-5.2 7.5-10V6L12 3Z" />
            <path d="m8.5 12 2.3 2.3 4.7-4.6" />
          </svg>
          <span v-if="!compact">Super Admin</span>
        </span>
      </template>
      <span>{{ description }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: 'SuperAdminBadge',
  data: () => ({ tooltipOpen: false }),
  props: {
    compact: { type: Boolean, default: false },
    focusable: { type: Boolean, default: true },
    description: { type: String, default: 'Super Admin에게만 표시되는 UI입니다.' },
  },
  computed: {
    isSuperAdmin() {
      return this.$store?.state.user_info?.organization_permission === 'super_admin'
    },
  },
  mounted() {
    // Use the enclosing control's keyboard focus without adding a nested tab stop.
    if (!this.focusable) {
      this.focusTarget = this.$el.closest?.('button, summary, [role="checkbox"]')
      this.focusTarget?.addEventListener('focus', this.showTooltip)
      this.focusTarget?.addEventListener('blur', this.hideTooltip)
      this.focusTarget?.addEventListener('keydown', this.onKeydown)
    }
  },
  beforeDestroy() {
    this.focusTarget?.removeEventListener('focus', this.showTooltip)
    this.focusTarget?.removeEventListener('blur', this.hideTooltip)
    this.focusTarget?.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    showTooltip() { this.tooltipOpen = true },
    hideTooltip() { this.tooltipOpen = false },
    onKeydown(event) { if (event.key === 'Escape') this.hideTooltip() },
  },
}
</script>

<style scoped>
.super-admin-badge-host {
  display: inline-flex;
  flex: 0 0 auto;
  margin-left: 6px;
  vertical-align: middle;
  line-height: 20px;
}
.super-admin-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 20px;
  padding: 0 6px;
  border-radius: 5px;
  background: #F0F2FF;
  color: #687EFF;
  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: normal;
  white-space: nowrap;
  vertical-align: middle;
  cursor: help;
}
.super-admin-badge svg { flex-shrink: 0; }
.super-admin-badge--compact { width: 20px; padding: 0; }
.super-admin-badge:focus-visible { outline: 2px solid #687EFF; outline-offset: 2px; }
</style>
